<template>
  <v-form>
    <v-row dense>
      <v-col cols="4">
        <v-text-field
          type="text"
          autocomplete="off"
          outlined
          dense
          label="Container Label"
          v-model="record.Name"
        ></v-text-field>
      </v-col>

      <v-col cols="4">
        <v-text-field
          type="number"
          autocomplete="off"
          outlined
          dense
          label="Total Lines"
          v-model="record.Lines"
        ></v-text-field>
      </v-col>

      <v-col cols="4">
        <v-text-field
          type="number"
          autocomplete="off"
          outlined
          dense
          label="Cost Per Line"
          v-model="record.LineCost"
        ></v-text-field>
      </v-col>

      <v-col cols="4">
        <span style="font-weight: bold; font-size: 18px">Date: {{ date }}</span>
      </v-col>

      <v-col cols="12">
        <v-btn
          v-if="docCreate == true"
          color="accent"
          @click="sendData"
          :loading="$store.state.btnLoader"
        >
          <v-icon left>mdi-content-save</v-icon>Save
        </v-btn>

        <v-btn
          v-else
          color="accent"
          @click="sendData"
          :loading="$store.state.btnLoader"
        >
          <v-icon left>mdi-content-save</v-icon>Update
        </v-btn>
      </v-col>
    </v-row>
  </v-form>
</template>


<script>
export default {
  name: "StoresIndex",
  props: {
    initial: {
      type: Object,
      required: true,
    },
    docCreate: {
      type: Boolean,
    },
  },
  computed: {
    activeStore() {
      return localStorage.getItem("store_id");
    },
  },
  data: () => ({
    record: {},
    loader: false,
    industries: [],
    drivers: [],
    date: new Date().toISOString().substr(0, 10),
  }),
  watch: {
    initial: {
      handler: "init",
      immediate: true,
    },
  },
  methods: {
    init(val) {
      this.record = { ...val };
    },
    setDate(date) {
      this.record.date = date;
    },
    sendData() {
      this.loader = true;
      this.record.StrType = 2;
      this.record.store_id = this.activeStore;
      this.record.DocDate = new Date().toISOString().substr(0, 10);
      this.$store.commit("btnLoader", true);
      this.$emit("data", this.record);
    },
    getIndustries() {
      const self = this;
      this.$store
        .dispatch("get", `/industries`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.industries = res.ResponseData;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    getDrivers() {
      const self = this;
      this.$store
        .dispatch("get", `/drivers`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.drivers = res.ResponseData;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
  },
  created() {
    Promise.all([this.getIndustries(), this.getDrivers()]);
  },
};
</script>